'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'link-simple';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e1cd';
var svgPathData = ['M160 256c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32z', 'M160 96C71.6 96 0 167.6 0 256s71.6 160 160 160l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-53 0-96-43-96-96s43-96 96-96l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0zm256 0l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c53 0 96 43 96 96s-43 96-96 96l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c88.4 0 160-71.6 160-160s-71.6-160-160-160z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faLinkSimple = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;